import { useEffect, useState, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { calculateRating } from 'src/config/RatingCalculation';
import getReviews from 'src/api/services/reviews/getReviews';
import { getTeamById } from 'src/api/services/teams/getTeam';
import { useCompanyData } from '../contexts/DataContext';

const useServiceCard = ({service,productType,companyId,courseDeliver}) => {
  const isMounted = useRef(null);
  const navigate = useNavigate();
  const { id } = useParams();
  const [rating, setRating] = useState(0);
  const [reviews, setReviews] = useState(0);
  const [instructor, setInstructor] = useState({});
  const { data } = useCompanyData();
  const { companyDomain,company } = data || {};
  const partnerId = company?.owner || '';
  const handleClick = () => {
    if(productType === 'courses') {
      courseHandleClick();
    }
    else{
      navigate(productType === 'categories' ? (companyDomain ? `/temp/categories/${service.id}` : `/${id}/temp/categories/${service.id}`) : (companyDomain ? `/temp/services/${service.id}` : `/${id}/temp/services/${service.id}`) );
    }
  };

  const courseHandleClick = () => {
    navigate(companyDomain ? `/temp/course/${service.id}` : `/${id}/temp/course/${service.id}`);
  };

  useEffect(() => {
    isMounted.current = true;
    const fetchReviews = async (serviceId) => {
      const reviews = await getReviews(serviceId,'serviceId');
      if(isMounted.current){
        setRating(calculateRating(reviews));
        setReviews(reviews.length);
      }
    };

     const fetchInstructorName = async (courseDeliver) => {
      const teamData = await getTeamById(courseDeliver === 'myself' ? partnerId : courseDeliver,courseDeliver === 'myself' ? 'Partners' : 'PartnerTeams');
      if(isMounted.current && teamData && Object?.keys(teamData).length > 0) {
        setInstructor({
          firstName: teamData.firstName || '',
          lastName: teamData.lastName || '',
          id: teamData.id || '',
          avatar: teamData.avatar || '',
        });
      }
    };

    fetchReviews(service.id);
    if(courseDeliver) fetchInstructorName(courseDeliver);
    return () => isMounted.current = false;
  }, [service.id]);

  return { handleClick, courseHandleClick, rating, reviews, instructor };
};

export default useServiceCard;
